import { toast } from "react-toastify";

const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
  "application/vnd.ms-outlook", 
  "message/rfc822", 
  "application/vnd.ms-excel", 
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
  "text/csv", 
];

const ALLOWED_EXTENSIONS = [
  "pdf",
  "jpg",
  "jpeg",
  "png",
  "webp",
  "msg",
  "eml",
  "xls",
  "xlsx",
  "csv",
];

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const useAttachmentValidator = () => {
  const validateAttachments = (files) => {
    const validFiles = [];
    const invalidFiles = [];
    const oversizedFiles = [];

    Array.from(files).forEach((file) => {
      const ext = file.name.split(".").pop().toLowerCase();

      const isValidType =
        ALLOWED_MIME_TYPES.includes(file.type) ||
        ALLOWED_EXTENSIONS.includes(ext);

      const isValidSize = file.size <= MAX_FILE_SIZE;

      if (!isValidType) {
        invalidFiles.push(file.name);
      } else if (!isValidSize) {
        oversizedFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    });

    if (invalidFiles.length > 0) {
      toast.error(
        "Only PDF, images, email files (.msg, .eml), and Excel/CSV files are allowed"
      );
    }

    if (oversizedFiles.length > 0) {
      toast.error("File size should not exceed 10MB");
    }

    return validFiles;
  };

  return { validateAttachments };
};

export default useAttachmentValidator;
